/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', function() {
    // Metaobject Links & Others Patch
    linkAriaLabel();
    // OneTrust Patch
    oneTrustAccordionADA();
});

// Description: Add aria-label to links missing title, aria-label, or aria-labelledby
// Reason: Shopify metaobject richtext links won't add the assigned title.
function linkAriaLabel() {
    const links = document.querySelectorAll('a');

    // Iterate over each link
    links.forEach(link => {
        // Check if the link doesn't have the attributes title, aria-label, or aria-labelledby
        if (!link.hasAttribute('title') && !link.hasAttribute('aria-label') && !link.hasAttribute('aria-labelledby')) {
            // Use the link content to add aria-label, but if only two or less words, then append a dash, then the last part of the link URL after the last /, and replace - with a space.
            const linkText = link.textContent.trim().replace(/\b\w/g, c => c.toUpperCase());
            if (linkText.split(' ').length > 2) {
                link.setAttribute('aria-label', linkText);
            } else {
                const linkUrlContext = link.pathname === '/' ? 'To Home Page' : link.pathname.split('/').pop().replace('-', ' ').replace(/\b\w/g, c => c.toUpperCase());
                if (linkText) {
                    link.setAttribute('aria-label', `${linkText} - ${linkUrlContext}`);
                } else {
                    link.setAttribute('aria-label', linkUrlContext);
                }
            }
        }
    });
}

// OneTrust ADA Fixes
function oneTrustAccordionADA() {
    // Check if element with ID 'onetrust-consent-sdk' exists, if not wait 100 ms and check again before running the function
    if (!document.getElementById('onetrust-consent-sdk')) {
        setTimeout(oneTrustAccordionADA, 100);
        return;
    }
    
    // Description: Get all elements with class 'ot-category-desc', take it's ID and move it to it's parent element with class 'ot-acc-txt'
    // Reason: This is to fix the OneTrust accordion's button's control element assigned to opening div instead of <p> element
    const categoryDesc = document.querySelectorAll('.ot-category-desc');
    categoryDesc.forEach(desc => {
        const descId = desc.id;
        const parent = desc.closest('.ot-acc-txt');
        desc.removeAttribute('id');
        parent.setAttribute('id', descId);
    });

    // Description: Fix specific button with aria-labelledby attribute pointing to non-existing element ID
    // Reason: This button has broken ARIA reference, so this function will remove the non-existing ID from the aria-labelledby attribute
    const openButton = document.querySelector('div[data-optanongroupid="BG1"] > button');
    const entries = openButton ? openButton.getAttribute('aria-labelledby').split(' ') : [];
    // Iterate through entries, check if ID exists, if not remove it from the array
    entries.forEach(entry => {
        if (!document.getElementById(entry)) {
            const index = entries.indexOf(entry);
            entries.splice(index, 1);
        }
    });
    // Update the aria-labelledby attribute with the updated entries
    if (openButton) {
        openButton.setAttribute('aria-labelledby', entries.join(' '));
    }
}

// Cart property logic
(async function () {
  const THRESHOLD = 15000;
  const PROPERTY_KEY = '_threshold';

  await customElements.whenDefined('interactive-cart');

  const { InteractiveCart } = await import('cart-components');

  let isUpdating = false;

  InteractiveCart.registerPlugin(100, async function (Cart, element, cart) {
    if (isUpdating) return;
    isUpdating = true;

    try {
      const meetsThreshold = cart.total_price >= THRESHOLD;
      const propertyVal = meetsThreshold ? 'true' : 'false';

      const itemsToUpdate = cart.items.filter(item => {
        const props = item.properties || {};
        const currentVal = props[PROPERTY_KEY];
        return currentVal !== propertyVal;
      });

      if (itemsToUpdate.length === 0) return;

      for (const item of itemsToUpdate) {
        const updatedProperties = { ...item.properties, [PROPERTY_KEY]: propertyVal };

        try {
          await Cart.change({
            id: item.key,
            quantity: item.quantity,
            properties: updatedProperties
          });
        } catch (err) {
          if (err.name !== 'AbortError') {
            console.error('[Cart Props] Failed to update item:', item.key, err);
          }
        }
      }
    } catch (err) {
      console.error('[Cart Props] Plugin error:', err);
    } finally {
      isUpdating = false;
    }
  });

})();